import { render } from "./SchoolTableComponent.vue?vue&type=template&id=aaa75da4"
import script from "./SchoolTableComponent.vue?vue&type=script&lang=js"
export * from "./SchoolTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__